<template>
  <span>
    <span v-if="displayOnly">{{displayValue}}</span>
    <input v-else :class="inputClass" type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" v-on:keydown.enter.prevent/>
  </span>
</template>

<script>
export default {
  name: 'VCurrencyInput',
  props: ['value', 'input-class', 'display-only', 'decimal-char'],
  data: function() {
    return {
      isInputActive: false,
      decimal: ','
    }
  },
  computed: {
    displayValue: {
      get: function() {
        let value = this.value;
        // change value to zero if no number is passed
        if(this.value === null) {
          this.$emit('input', 0)
          value = 0;
        }

        if (this.isInputActive) {
          return this.getFormattedForInput(value, false);
        } else {
          // User is not modifying now. Format display value for user interface
          value = value.toString();

          value = parseFloat(value.replace(/,/g, '.')).toFixed(2);

          // Ensure that it is not NaN
          if (isNaN(value)) {
            value = 0;
          }

          this.$emit('input', parseFloat(value));

          return this.getFormattedForInput(value, true);
        }
      },
      set: function(modifiedValue) {
        // Recalculate value after ignoring "$", "," and "." in user input
        const regExp = new RegExp('[^\\d\\.,]', 'g');
        let newValue = modifiedValue.replace(regExp, "")

        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    getFormattedForInput(value) {
      let displayValue = value.toString();

      const regExp = new RegExp('[^\\d\\.,]', 'g');
      displayValue = displayValue.replace(regExp, "");

      if(this.decimal === ',') {
        displayValue = displayValue.replace(/\./, ',');
      }

      return displayValue
    }
  },
  mounted() {
    this.decimal = this.decimalChar || this.decimal;
  }
}
</script>

<style>

</style>
